import React from 'react';
import {
  TextContainer,
  SkeletonDisplayText,
  SkeletonBodyText,
} from '@shopify/polaris';

import styles from './ServiceDetails.scss';

export function SkeletonServiceDetails() {
  return (
    <div className={styles.ServiceDetails}>
      <TextContainer spacing="tight">
        <SkeletonDisplayText size="large" />
        <SkeletonBodyText lines={4} />
      </TextContainer>
      <div className={styles.QuestionsAnswers}>
        <TextContainer spacing="tight">
          <SkeletonDisplayText size="small" />
          <SkeletonBodyText lines={3} />
        </TextContainer>
      </div>
    </div>
  );
}
